<script lang="ts">
	import DropdownContentPortal from './DropdownContentPortal.svelte'
	import { type Snippet } from 'svelte'
	import { fly } from 'svelte/transition'

	interface Props {
		portal?: boolean
		placeholderElement: HTMLDivElement | null
		onClickOutsidePortal?: () => void
		children?: Snippet
	}

	let { portal = false, placeholderElement, onClickOutsidePortal, children }: Props = $props()
</script>

{#snippet content(children)}
	<div class="relative z-30" transition:fly|global={{ x: 0, y: -10, duration: 200 }}>
		{@render children?.()}
	</div>
{/snippet}

{#if portal}
	<DropdownContentPortal {placeholderElement} {onClickOutsidePortal} {content}>
		{@render children?.()}
	</DropdownContentPortal>
{:else}
	{@render content(children)}
{/if}
